import { useContext, useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom'; // Link 컴포넌트를 임포트합니다.
import './Header.css'; // 스타일링을 위한 CSS 파일을 임포트합니다.
import { DialogContext } from '../context/DialogContext';
import { PersonContext } from '../context/PersonContext';
import PersonLogin from '../pages/person/login'; // 로그인 컴포넌트를 임포트합니다.
import Hamburger from './Hamburger';
import PersonModify from '../pages/person/modify';

const Header = () => {
  const { openDialog } = useContext(DialogContext); // closeDialog 추가
  const { person, logout } = useContext(PersonContext);
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const navigate = useNavigate();

  const openLoginDialog = () => {
    const customStyles = {
      overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)', // 배경 색상
      },
      content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        padding: '0',
      },
    };

    openDialog(<PersonLogin />, customStyles);
  };

  const openModifyDialog = () => {
    const customStyles = {
      overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)', // 배경 색상
      },
      content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        padding: '0',
      },
    };

    openDialog(<PersonModify />, customStyles);
  };

  const handleLogout = () => {
    logout();
    // /페이지로 이동
    window.location.href = '/';
  };

  const isLoggedIn = !!person;

  // 메뉴 바깥 클릭 시 닫힘
  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    }
    if (menuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [menuOpen]);

  return (
    <header className="header">
      <div>
        <button onClick={() => navigate('/')} className="back-btn">&lt;</button>
        <a href="https://www.klata.or.kr" className="logo" target="_blank" rel="noreferrer">한국실용글쓰기검정</a>
        <Link to="/" className="root">감독관</Link>
      </div>
      <nav>
        <div className="dropdown" ref={menuRef}>
          <button
            type="button"
            onClick={() => setMenuOpen(v => !v)}
            className="menu-btn"
            aria-label="메뉴 열기"
          >
            <Hamburger/>
          </button>
          <div className={`side-menu${menuOpen ? ' open' : ''}`}>
            <button
              className="close-btn"
              onClick={() => setMenuOpen(false)}
              aria-label="메뉴 닫기"
            >
              ×
            </button>
            <ul className="side-menu-top">
              <li>
                {person ? person.name : ''}
              </li>
              {isLoggedIn ? (
                <>
                  <li><button onClick={handleLogout}>로그아웃</button></li>
                  <li><button onClick={openModifyDialog}>정보수정</button></li>
                </>
              ) : (
                <>
                  <li><button onClick={openLoginDialog}>로그인</button></li>
                </>
              )}
            </ul>
            <ul className="side-menu-list">
              <li><Link to="/person/account" onClick={() => setMenuOpen(false)}>계좌 설정</Link></li>
              <li><Link to="/testing_teacher_document/list" onClick={() => setMenuOpen(false)}>서명서류목록</Link></li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;